const ITEMS = [
  "We breathe in colours and elegance",
  "Pure Banarasi · Heirloom Kanjeevaram",
  "Pan-India Shipping",
  "Bridal Consultations By Appointment",
  "Hand-block Prints & Designer Edits",
  "Airport Road · Indore",
  "Three Decades of Heritage",
];

export const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-garnet text-cream py-4 overflow-hidden border-y border-garnet-deep">
      <div className="flex marquee-track whitespace-nowrap">
        {loop.map((t, i) => (
          <span
            key={i}
            className="mx-8 inline-flex items-center gap-8 text-[11px] tracking-[0.32em] uppercase"
          >
            <span className="text-gold">✦</span> {t}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
